import React from "react";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";

const Card = (props) => {
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="user-content">
            <div className="update-name-div">
              <p className="small text-muted mb-0 pl0 line-break-4">
                <Link to={`/super-admin/${props.data?.id}`}>
                  {props.data?.old?.firstName + " " + props.data?.old?.lastName}
                </Link>
              </p>
              <p className="small text-muted mb-0 pl0 line-break-4">
                <b>Updated At :</b>{" "}
                {props.data?.new?.modifiedAt.toDate().toDateString()}
              </p>
            </div>
            <div className="testimonial-btns">
              {props.superAdmin && props.data && (
                <>
                  <Link to={`/updatehistory/${props.data?.id}`} target="_blank">
                    <Button circular icon="linkify" color="blue" />
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;
